import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getCandidateById } from '../api';
import ImageLightbox from '../components/ImageLightbox';
import SocialShare from '../components/SocialShare';
import '../styles/CandidatePage.css';

const CandidatePage = () => {
  const { id } = useParams();
  const [candidate, setCandidate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  useEffect(() => {
    getCandidateById(id)
      .then(data => {
        // Приведение поля achievement_images к массиву, если пришла строка JSON
        if (data && data.achievement_images && typeof data.achievement_images === 'string') {
          try {
            data.achievement_images = JSON.parse(data.achievement_images);
          } catch (e) {
            data.achievement_images = [];
          }
        }
        setCandidate(data);
        setLoading(false);
      })
      .catch(error => {
        console.error(error);
        setLoading(false);
      });
  }, [id]);

  const getImageUrl = (path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    return `http://localhost:5000${path}`;
  };

  const achievementImages = Array.isArray(candidate?.achievement_images)
    ? candidate.achievement_images.map(img => getImageUrl(img))
    : [];

  const openLightbox = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  if (loading) return <div className="loading">Загрузка...</div>;
  if (!candidate) return <div className="not-found">Кандидат не найден</div>;

  return (
    <div className="candidate-page">
      <div className="candidate-header">
        <div className="candidate-photo">
          {candidate.photo ? (
            <img src={getImageUrl(candidate.photo)} alt={candidate.name} />
          ) : (
            <div className="no-photo-placeholder">Фото отсутствует</div>
          )}
        </div>
        <div className="candidate-title">
          <h1>{candidate.name}</h1>
          <p className="candidate-position">{candidate.position}</p>
          <div className="candidate-short-bio">{candidate.bio}</div>
          <SocialShare title={candidate.name} url={window.location.href} />
        </div>
      </div>

      <div className="candidate-content">
        <div className="container">
          {candidate.pageContent ? (
            <div dangerouslySetInnerHTML={{ __html: candidate.pageContent }} />
          ) : (
            <p>Полная информация о кандидате будет добавлена позже.</p>
          )}
        </div>
      </div>

      {achievementImages.length > 0 && (
        <div className="achievements-gallery">
          <h2>Достижения кандидата</h2>
          <div className="gallery-grid">
            {achievementImages.map((img, idx) => (
              <div key={idx} className="gallery-item" onClick={() => openLightbox(idx)}>
                <img src={img} alt={`Достижение ${idx + 1}`} />
              </div>
            ))}
          </div>
        </div>
      )}

      {lightboxOpen && (
        <ImageLightbox
          images={achievementImages}
          currentIndex={lightboxIndex}
          onClose={(newIndex) => {
            if (typeof newIndex === 'number') setLightboxIndex(newIndex);
            else setLightboxOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default CandidatePage;